import { isArray } from 'util';
import { OperatorCalendar, OperatorCalendarDay, OperatorCalendarEntry, OperatorCalendarShift } from '../operator-calendar';
import { MachineGroupScheduleTimeRangeBuilder } from './machine-group-schedule-time-range.builder';
import { OperatorBuilder } from './operator.builder';

export class OperatorCalendarBuilder {
  static entryFromJson(json) {
    return (json)
      ? new OperatorCalendarEntry(
        json.operatorHash,
        json.plannedShift,
        json.shift,
        json.available,
        json.startTime,
        json.endTime,
        json.exceptionType,
      )
      : null;
  }

  static entriesFromList(list) {
    return (isArray(list)) ? list.map(OperatorCalendarBuilder.entryFromJson) : [];
  }

  static shiftFromJson(json) {
    return (json)
      ? new OperatorCalendarShift(
        json.shift,
        json.working,
        json.startTime,
        json.endTime,
        OperatorCalendarBuilder.entriesFromList(json.operators),
      )
      : null;
  }

  static dayFromJson(json) {
    return (json)
      ? new OperatorCalendarDay(
        json.date,
        json.year,
        json.week,
        json.working,
        json.colors || [],
        MachineGroupScheduleTimeRangeBuilder.fromList(json.timeRanges),
        (isArray(json.shifts)) ? json.shifts.map(OperatorCalendarBuilder.shiftFromJson) : [],
        OperatorCalendarBuilder.entriesFromList(json.unassignedOperators),
      )
      : null;
  }

  static fromJson(json) {
    return (json)
      ? new OperatorCalendar(
        json.workingModelGroupHash,
        json.startDate,
        json.endDate,
        OperatorBuilder.fromList(json.operators),
        (isArray(json.days)) ? json.days.map(OperatorCalendarBuilder.dayFromJson) : [],
      )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operator-calendar.builder.ts